export class NumericTestsDefinition {

    ItemId: number;
    TestCode: string;
    Description: string;
    OtherDescription: string;

}
